module.exports = __webpack_public_path__ + "static/media/BombaGasolinaEGP10.4d6f1e0d.pdf";